<template>
  <div class="px-3 py-4 layout-row layout-wrap">

    <!-- Primärtumor ICD10-Code -->

<!--    <div class="flex-gt-sm-50 flex-100 px-2">-->
<!--      <v-text-field-->
<!--        :label="$t('FORMS_DIVERSE.ICD_CODE')"-->
<!--        :color="compColor.primeColor"-->
<!--        :dark="compColor.isInDarkMode"-->
<!--        v-model="model.code"-->
<!--        disabled-->
<!--        :dense="denseFields"-->
<!--        outlined-->
<!--      ></v-text-field>-->
<!--    </div>-->

    <!-- Primärtumor Diagnosedatum -->

<!--    <div class="flex-gt-sm-50 flex-100 px-2">-->
<!--      <validation-provider tag="div"-->
<!--                           :name="path + '.date'"-->
<!--                           :ref="path + '.date'"-->
<!--                           rules="required|german_date|date_not_in_future"-->
<!--                           class="flex layout-column"-->
<!--                           v-slot="{ errors }">-->
<!--        <lx-datepicker-->
<!--          :color="compColor.textInput"-->
<!--          :name="path + '.date'"-->
<!--          :label="$t('FORMS_DIVERSE.ICD_CODE_DATE')"-->
<!--          class="mr-1"-->
<!--          :error="errors[0]"-->
<!--          :dense="denseFields"-->
<!--          v-model="model.date"-->
<!--        ></lx-datepicker>-->
<!--      </validation-provider>-->
<!--    </div>-->

    <!-- Primärtumor Diagnosesicherung -->

    <div class="flex-100 px-2 mb-6">
      <validation-provider tag="div"
                           :name="path + '.additionalFields.register.diagnosesicherung'"
                           :ref="path + '.additionalFields.register.diagnosesicherung'"
                           rules=""
                           class="flex layout-column"
                           v-slot="{ errors }">
        <fake-input-frame :label="$t('FORMS_DIVERSE.ICD_CODE_DIAGNOSTIC_ASSURANCE')">
          <div class="layout-column pa-4 flex">
            <v-radio-group v-model="model.additionalFields.register.diagnosesicherung" hide-details
                           :error-messages="errors[0]"
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio v-for="(type, typesIndex) in DiagnosesicherungTypes"
                       :label="type.text"
                       :value="type.value"
                       :key="typesIndex"
                       :title="type.title"
                       :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                       class="mb-1"
                       :dark="compColor.isInDarkMode">
              </v-radio>
              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2 mt-1"
                     @click="model.additionalFields.register.diagnosesicherung=undefined"
                     v-show="model.additionalFields.register.diagnosesicherung"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                        size="24">mdi-arrow-up-bold
                </v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </fake-input-frame>
      </validation-provider>
    </div>

    <!-- Primärtumor Seitenlokalisation -->

    <div class="flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.additionalFields.register.seitenlokalisation'"
                           :ref="path + '.additionalFields.register.seitenlokalisation'"
                           class="flex layout-column"
                           :rules="{required: !!isPairedPrimaryTumor(model.code)}"
                           v-slot="{ errors }">
        <fake-input-frame
          :label="isPairedPrimaryTumor(model.code) ? $t('FORMS_DIVERSE.ICD_CODE_SIDE_LOCALIZATION_PAIRED_TUMOR') + ' *' : $t('FORMS_DIVERSE.ICD_CODE_SIDE_LOCALIZATION')">
          <div class="layout-column pa-4 flex">
            <v-radio-group v-model="model.additionalFields.register.seitenlokalisation" hide-details
                           :error-messages="errors[0]"
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio v-for="(value, key) in getSideLocalizationTypes(model.code)"
                       :label="value"
                       :value="key"
                       :key="key"
                       :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                       class="mb-1"
                       :dark="compColor.isInDarkMode">
              </v-radio>
              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2 mt-2"
                     @click="model.additionalFields.register.seitenlokalisation=undefined"
                     v-show="model.additionalFields.register.seitenlokalisation && !isPairedPrimaryTumor(model.code)"
                     :disabled="!model.additionalFields.register.seitenlokalisation"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                        size="24">mdi-arrow-up-bold
                </v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </fake-input-frame>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import metaData from '../../../components/documentation/shared/formsMetaData'

export default {
  name: "Register",
  mixins: [metaData],
  props: {
    value: {
      type: Object,
      default: () => ({ additionalFields: { register: {} } })
    },
    path: {
      type: String
    }
  },
  data () {
    return {
      model: {
        additionalFields: { register: {} }
      },
      DiagnosesicherungTypes: null,
      PairedTumorList: [],
      PairedAdditionalTumors: {},
      SeitenlokalisationTypes: null,
      SeitenlokalisationTypesPairedTumors: null
    }
  },
  created () {
    this.DiagnosesicherungTypes = this.formsMetaData.DiagnosesicherungTypes
    this.PairedTumorList = this.formsMetaData.PairedTumorList
    this.PairedAdditionalTumors = this.formsMetaData.PairedAdditionalTumors
    this.SeitenlokalisationTypes = this.formsMetaData.SeitenlokalisationTypes
    this.SeitenlokalisationTypesPairedTumors = this.formsMetaData.SeitenlokalisationTypesPairedTumors
  },
  methods: {
    /**
     *  Return true is primary tumor is paired tumor
     *
     * @param code The icd-10 code of primary tumor
     * @returns {boolean|*}
     */
    isPairedPrimaryTumor (code) {
      return this.PairedTumorList.indexOf(code) > -1 || this.PairedAdditionalTumors[code]
    },

    /**
     * Return list of side localizations in dependency to existing paired primary tumor
     *
     * @param code The icd-10 code of primary tumor
     * @returns {default.formsMetaData.SeitenlokalisationTypesPairedTumors|{R: string, L: string}|null}
     */
    getSideLocalizationTypes (code) {
      return this.PairedTumorList.indexOf(code) > -1 || this.PairedAdditionalTumors[code] ? this.SeitenlokalisationTypesPairedTumors : this.SeitenlokalisationTypes
    },
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          if (!this.model.additionalFields) {
            this.$set(this.model, 'additionalFields', { register: {} })
          }
        }
      },
      immediate: true
    }
  }
}
</script>
